import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationViewerComponent } from './translation-viewer.component';
import { HighlightPipeModule } from '@schoolbelle/shared/pipes';

@NgModule({
  declarations: [TranslationViewerComponent],
  imports: [
    CommonModule,
    HighlightPipeModule,
  ],
  exports: [
    TranslationViewerComponent,
    CommonModule,
    HighlightPipeModule,

  ],
})
export class TranslationViewerModule {}
